import "./InputAdcWrapper.css";

function InputAdcWrapper({
  value,
  onChange,
  placeholder,
  type = "text",
  disabled = false,
  wrapperClassName = "",
  inputClassName = "",
  iconClassName = "",
  iconSrc = "/imagens/search.svg",
  iconAlt = "",
  onIconClick,
  width,
  "data-testid": dataTestId,
}) {
  const wrapperStyle = width ? { width } : undefined;
  const isIconClickable = typeof onIconClick === "function";

  return (
    <div
      className={`input-adc-wrapper ${wrapperClassName}`.trim()}
      style={wrapperStyle}
      data-testid={dataTestId}
    >
      <input
        className={`input-adc-input ${inputClassName}`.trim()}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />

      <img
        src={iconSrc}
        alt={iconAlt}
        className={`input-adc-icon ${iconClassName}`.trim()}
        onClick={onIconClick}
        style={isIconClickable ? { cursor: "pointer" } : undefined}
      />
    </div>
  );
}

export default InputAdcWrapper;
